import React, { useState } from "react";
import { Button, Row, Col, Card, Avatar, Input, Tag } from "antd";
import { SendOutlined } from "@ant-design/icons";
import {
  Container,
  Content,
  TicketCard,
  TicketList,
  TicketView,
  ButtonGroup,
  TicketViewHeader,
} from "./styles";
import Header from "../../components/header";
import Status from "../../components/status";
import userPhoto from "../../images/user.png";

const initialTickets = [
  {
    id: "#001",
    user: {
      name: "João da Silva",
      photo: userPhoto,
    },
    lastMessage: "Olá, estou com um problema na minha fatura.",
    timestamp: "2025-10-15T10:00:00",
    status: "aberto",
    messages: [
      {
        id: 1,
        text: "Olá, estou com um problema na minha fatura.",
        sender: "user",
        timestamp: "2025-10-15T10:00:00",
      },
      {
        id: 2,
        text: "Olá João, em que posso ajudar?",
        sender: "attendant",
        timestamp: "2025-10-15T10:01:00",
      },
    ],
  },
  {
    id: "#002",
    user: {
      name: "Maria Oliveira",
      photo: userPhoto,
    },
    lastMessage: "Não consigo acessar minha conta.",
    timestamp: "2025-10-15T09:30:00",
    status: "finalizado",
    messages: [
      {
        id: 1,
        text: "Não consigo acessar minha conta.",
        sender: "user",
        timestamp: "2025-10-15T09:30:00",
      },
      {
        id: 2,
        text: "Problema resolvido.",
        sender: "attendant",
        timestamp: "2025-10-15T09:35:00",
      },
    ],
  },
  {
    id: "#003",
    user: {
      name: "Carlos Pereira",
      photo: userPhoto,
    },
    lastMessage: "Gostaria de saber mais sobre o plano Pro.",
    timestamp: "2025-10-15T11:00:00",
    status: "andamento",
    messages: [
      {
        id: 1,
        text: "Gostaria de saber mais sobre o plano Pro.",
        sender: "user",
        timestamp: "2025-10-15T11:00:00",
      },
    ],
  },
];

const Atendimentos = () => {
  const [tickets, setTickets] = useState(initialTickets);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [filter, setFilter] = useState("all");
  const [newMessage, setNewMessage] = useState("");

  const handleTicketClick = (ticket) => {
    setSelectedTicket(ticket);
  };

  const handleBackToList = () => {
    setSelectedTicket(null);
  };

  const handleStatusChange = (ticketId, newStatus) => {
    const updatedTickets = tickets.map((t) =>
      t.id === ticketId ? { ...t, status: newStatus } : t
    );
    setTickets(updatedTickets);
    setSelectedTicket(updatedTickets.find((t) => t.id === ticketId));
  };

  const handleSendMessage = () => {
    if (newMessage.trim() && selectedTicket) {
      const newMessageObj = {
        id: Date.now(),
        text: newMessage,
        sender: "attendant",
        timestamp: new Date().toISOString(),
      };
      const updatedTickets = tickets.map((t) =>
        t.id === selectedTicket.id
          ? { ...t, messages: [...t.messages, newMessageObj] }
          : t
      );
      setTickets(updatedTickets);
      setSelectedTicket(updatedTickets.find((t) => t.id === selectedTicket.id));
      setNewMessage("");
    }
  };

  const getStatusDisplay = (status) => {
    switch (status) {
      case "aberto":
        return "Aberto";
      case "andamento":
        return "Em Andamento";
      case "finalizado":
        return "Finalizado";
      default:
        return status;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "aberto":
        return "blue";
      case "andamento":
        return "orange";
      case "finalizado":
        return "green";
      default:
        return "default";
    }
  };

  const openTicketsCount = tickets.filter(
    (t) => t.status !== "finalizado"
  ).length;
  const allTicketsCount = tickets.length;

  const filteredTickets =
    filter === "open"
      ? tickets.filter((t) => t.status !== "finalizado")
      : tickets;

  if (selectedTicket) {
    return (
      <Container>
        <Content>
          <TicketView>
            <TicketViewHeader>
              <Button onClick={handleBackToList} style={{ marginRight: 16 }}>
                Voltar
              </Button>
              <h2>Chamado {selectedTicket.id}</h2>
              <Status status={selectedTicket.status} />
              <div className="ticket-actions">
                {selectedTicket.status === "aberto" && (
                  <Button
                    type="primary"
                    onClick={() =>
                      handleStatusChange(selectedTicket.id, "andamento")
                    }
                  >
                    Iniciar Atendimento
                  </Button>
                )}
                {selectedTicket.status === "andamento" && (
                  <Button
                    danger
                    onClick={() =>
                      handleStatusChange(selectedTicket.id, "finalizado")
                    }
                  >
                    Fechar Atendimento
                  </Button>
                )}
              </div>
            </TicketViewHeader>
            <div className="chat-window-body">
              {selectedTicket.messages.map((msg) => (
                <div
                  key={msg.id}
                  className={`message ${
                    msg.sender === "user" ? "received" : "sent"
                  }`}
                >
                  <div className="message-content">{msg.text}</div>
                  <div className="message-timestamp">
                    {new Date(msg.timestamp).toLocaleTimeString()}
                  </div>
                </div>
              ))}
            </div>
            {selectedTicket.status !== "finalizado" && (
              <div className="chat-footer">
                <Input
                  placeholder="Digite sua mensagem..."
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onPressEnter={handleSendMessage}
                  suffix={
                    <Button
                      type="primary"
                      icon={<SendOutlined />}
                      onClick={handleSendMessage}
                    />
                  }
                />
              </div>
            )}
          </TicketView>
        </Content>
      </Container>
    );
  }

  return (
    <Container>
      <Content>
        <ButtonGroup>
          <Button
            shape="round"
            size="large"
            type={filter === "all" ? "primary" : "default"}
            onClick={() => setFilter("all")}
          >
            Todos os Chamados ({allTicketsCount})
          </Button>
          <Button
            shape="round"
            size="large"
            type={filter === "open" ? "primary" : "default"}
            onClick={() => setFilter("open")}
          >
            Chamados Abertos ({openTicketsCount})
          </Button>
        </ButtonGroup>
        <TicketList>
          {filteredTickets.map((ticket) => (
            <TicketCard
              key={ticket.id}
              onClick={() => handleTicketClick(ticket)}
            >
              <Card>
                <div className="card-header">
                  <span>{ticket.id}</span>
                  <Tag color={getStatusColor(ticket.status)}>
                    {getStatusDisplay(ticket.status)}
                  </Tag>
                </div>
                <Card.Meta
                  avatar={<Avatar src={ticket.user.photo} />}
                  title={ticket.user.name}
                  description={ticket.lastMessage}
                />
                <div className="ticket-info">
                  <span>
                    {new Date(ticket.timestamp).toLocaleDateString()}{" "}
                    {new Date(ticket.timestamp).toLocaleTimeString()}
                  </span>
                </div>
              </Card>
            </TicketCard>
          ))}
        </TicketList>
      </Content>
    </Container>
  );
};

export default Atendimentos;
